import { Pipe, PipeTransform } from '@angular/core';

import { colorMappingWarn } from '../constants/constants';

@Pipe({ name: 'colorMappingWarn' })
export class ColorMappingWarnPipe implements PipeTransform {
  transform(value: number) {
    return colorMappingWarn(value);
  }
}
